var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"type-radar"}},[_c('ve-radar',{staticClass:"graph",attrs:{"height":"420px","extend":{a: this.course.name},"after-config":_vm.afterConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }